import { camelizeObject } from '@cvt/helpers/object';

export const mapAssertionData = (data: Assertions.AssertionApi): Assertions.Assertion => {
  const assertion = camelizeObject<Assertions.Assertion>(data);
  return assertion;
};
export const mapNextAssertionData = (data: Assertions.NextAssertionApi): Assertions.NextAssertion => {
  return {
    ...camelizeObject<Assertions.NextAssertion>(data),
    nextAssertion: data.next_assertion && {
      ...mapAssertionData(data.next_assertion),
      reasoning: data.next_assertion.reasoning,
    },
  };
};
